import React from 'react';
import { Button } from '../../../components/base/Button';

export const CTASection: React.FC = () => {
  return (
    <section className="py-8 md:py-12 lg:py-24 relative">
      <div className="absolute inset-0" style={{background: 'linear-gradient(to right, rgba(15, 29, 43, 0.95), rgba(26, 43, 61, 0.9), rgba(153, 69, 0, 0.95))'}}></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-8 md:mb-16">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 md:px-6 md:py-3 bg-orange-500/20 border border-orange-500/30 rounded-full mb-6 md:mb-8">
            <span className="text-orange-300 font-semibold text-sm md:text-base">Comece Agora - É Grátis!</span>
          </div>

          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-6 md:mb-8">
            Escolha Seu <span className="text-orange-500">Caminho</span>
          </h2>
        </div>

        {/* Two Cards Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {/* Professional Card */}
          <div className="bg-white/10 backdrop-blur-lg rounded-xl md:rounded-3xl p-6 md:p-8 border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="text-center mb-6 md:mb-8">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <i className="ri-briefcase-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-3xl font-bold text-white mb-4 md:mb-6">Para Profissionais</h3>
              <p className="text-blue-200 text-base md:text-lg mb-6 md:mb-8">
                Expanda seus negócios e encontre novos clientes
              </p>
            </div>

            {/* Advantages List */}
            <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Acesso a milhares de clientes potenciais</span>
              </div>
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Gestão completa de projetos e orçamentos</span>
              </div>
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Pagamentos seguros e garantidos</span>
              </div>
              <div className="flex items-center space-x-3 md:space-x-4 hidden md:flex">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Avaliações que constroem sua reputação</span>
              </div>
              <div className="flex items-center space-x-3 md:space-x-4 hidden md:flex">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Suporte técnico especializado</span>
              </div>
            </div>

            {/* Professional Button */}
            <div className="text-center">
              <a 
                href="https://forms.gle/iSEceoYsLHpAJhxF9"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 md:px-8 md:py-4 rounded-lg md:rounded-2xl font-bold text-sm md:text-lg whitespace-nowrap transition-all duration-300 transform hover:scale-105 cursor-pointer"
              >
                <i className="ri-user-add-line mr-2 md:mr-3 text-lg md:text-xl"></i>
                Cadastrar como Profissional
              </a>
            </div>
          </div>

          {/* Client Card */}
          <div className="bg-white/10 backdrop-blur-lg rounded-xl md:rounded-3xl p-6 md:p-8 border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="text-center mb-6 md:mb-8">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <i className="ri-user-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-3xl font-bold text-white mb-4 md:mb-6">Para Clientes</h3>
              <p className="text-blue-200 text-base md:text-lg mb-6 md:mb-8">
                Realize seus projetos com profissionais qualificados
              </p>
            </div>

            {/* Advantages List */}
            <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Profissionais verificados e qualificados</span>
              </div>
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Compare orçamentos facilmente</span>
              </div>
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Acompanhamento em tempo real</span>
              </div>
              <div className="flex items-center space-x-3 md:space-x-4 hidden md:flex">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Garantia em todos os serviços</span>
              </div>
              <div className="flex items-center space-x-3 md:space-x-4 hidden md:flex">
                <div className="w-6 h-6 md:w-6 md:h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm md:text-sm"></i>
                </div>
                <span className="text-white text-sm md:text-base">Suporte durante todo o projeto</span>
              </div>
            </div>

            {/* Client Button */}
            <div className="text-center">
              <a 
                href="https://forms.gle/vyDyvwdnn3pdBBRW8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 md:px-8 md:py-4 rounded-lg md:rounded-2xl font-bold text-sm md:text-lg whitespace-nowrap transition-all duration-300 transform hover:scale-105 cursor-pointer"
              >
                <i className="ri-home-heart-line mr-2 md:mr-3 text-lg md:text-xl"></i>
                Cadastrar como Cliente
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};